import { lazy } from "react";
import { formatMYDate } from "../../../../../utils/dateUtils";
import ManagerZonePettyCashForm from "../forms/ManagerZonePettyCashForm";
import { IPettyCashCategoryServiceResponse } from "../../../../../Types/PettyCash";

const CommonModal = lazy(
  () => import("../../../../../Component/Ui-Kits/Modal/Common/CommonModal")
);

export interface IExpenseAddModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: number;
  expenseCategoryTypeOptions: IPettyCashCategoryServiceResponse;
}

const ExpenseAddModal = ({
  isOpen,
  onClose,
  userId,
  expenseCategoryTypeOptions,
}: IExpenseAddModalProps) => {
  return (
    <CommonModal
      headerClassName="bg-primary"
      titleClassName="text-white"
      title="Add Expense"
      modalBodyClassName="ps-lg-4"
      centered
      toggle={onClose}
      isOpen={isOpen}
      showFooter={false}
    >
      <ManagerZonePettyCashForm
        userId={userId}
        expenseCategoryTypeOptions={expenseCategoryTypeOptions}
      />
    </CommonModal>
  );
};

export default ExpenseAddModal;
